<template>
  <app-layout>
    <v-container fluid>
      <oficial-documents></oficial-documents>
    </v-container>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import OficialDocuments from '../components/OficialDocuments.vue';

export default {
  components: {
    AppLayout,
    OficialDocuments,
  },
};
</script>
